import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';

let filBundlePromise: Promise<void> | null = null;

/** Loads Filipino strings on demand so ~26KB JSON is not parsed on every first visit (TBT). */
export async function ensureFilipinoResources(): Promise<void> {
  if (i18n.hasResourceBundle('fil', 'translation')) return;
  if (!filBundlePromise) {
    filBundlePromise = import('./locales/fil/translation.json').then((mod) => {
      i18n.addResourceBundle('fil', 'translation', mod.default, true, true);
    });
  }
  await filBundlePromise;
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;